import { JsonProperty } from "@outfoxx/jackson-js";

export class Status {
    @JsonProperty()
    id: string;
    @JsonProperty()
    color: string;
    @JsonProperty()
    name: string;
}